import React from "react";
import { CheckCheck } from "lucide-react";
import { useNotifications } from "./NotificationContext";
import { useNavigate } from "react-router-dom";
import "./NotificationSystem.css";

export const NotificationIcon = ({ onToggle }) => {
  const {
    notifications,
    showDropdown,
    setShowDropdown,
    unreadCount,
    markAllAsRead,
    markAsRead,
  } = useNotifications();

  const navigate = useNavigate();

  const handleViewAllNotifications = () => {
    setShowDropdown(false);
    navigate("/notifications");
  };

  const handleToggleDropdown = (e) => {
    e.stopPropagation();
    const newState = !showDropdown;
    setShowDropdown(newState);
    if (onToggle) onToggle(newState);
  };

  React.useEffect(() => {
    // close dropdown when clicking outside
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".icon-container")) {
        setShowDropdown(false);
        if (onToggle) onToggle(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [setShowDropdown, onToggle]);

  const unreadNotifs = notifications.filter(
    (n) => !n.is_read || n.is_read === 0
  );
  const readNotifs = notifications.filter((n) => n.is_read || n.is_read === 1);

  const displayNotifs = [
    ...unreadNotifs.slice(0, 5),
    ...readNotifs.slice(0, 5 - unreadNotifs.length),
  ];

  return (
    <div className="icon-container">
      <button className="icon-button" onClick={handleToggleDropdown}>
        <div
          style={{
            width: "24px",
            height: "24px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitMask: `url("data:image/svg+xml;utf8,${encodeURIComponent(
              `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9'/><path d='M13.73 21a2 2 0 0 1-3.46 0'/></svg>`
            )}") center / contain no-repeat`,
            mask: `url("data:image/svg+xml;utf8,${encodeURIComponent(
              `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9'/><path d='M13.73 21a2 2 0 0 1-3.46 0'/></svg>`
            )}") center / contain no-repeat`,
          }}
        />
        {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
      </button>

      {showDropdown && (
        <div className="dropdown">
          <div className="dropdown-header">
            <h3>Notifications</h3>
            <button className="mark-all-btn" onClick={markAllAsRead}>
              <CheckCheck size={16} /> Mark all read
            </button>
          </div>
          <div className="dropdown-body">
            {displayNotifs.map((notif) => (
              <div
                key={notif.id}
                className={`notif-item ${notif.is_read === 0 ? "unread" : ""}`}
                onClick={() => markAsRead(notif.id)}
              >
                <div className="notif-content">
                  <p>{notif.message}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="view-all-btn" onClick={handleViewAllNotifications}>
            View All Notifications
          </button>
        </div>
      )}
    </div>
  );
};
